/**
 * @generated SignedSource<<30d79d8161af2389453f69051d090aa0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type timeline_nativeIssueTable_TimelineCellRenderer_issueEdge$data = {
  readonly __typename?: "JiraIssueEdge";
  readonly " $fragmentType": "timeline_nativeIssueTable_TimelineCellRenderer_issueEdge";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "timeline_nativeIssueTable_TimelineCellRenderer_issueEdge";
};
export type timeline_nativeIssueTable_TimelineCellRenderer_issueEdge$key = {
  readonly " $data"?: timeline_nativeIssueTable_TimelineCellRenderer_issueEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeline_nativeIssueTable_TimelineCellRenderer_issueEdge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "timeline_nativeIssueTable_TimelineCellRenderer_issueEdge",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "aa5c0623283141b9fc1d31581957f86d";

export default node;
